import React, {useEffect, useState} from 'react';
import FloatLabel from "../components/FloatLabel";
import {Form, Input} from "antd";

// Règle de validation avec regex
const numericRule = {
  pattern: /^[0-9]+([.,][0-9]{1,2})?$/,
  message: 'Veuillez saisir un nombre valide (ex: 123,45 ou 123.45)'
};

// Fonction pour bloquer la saisie de caractères non autorisés
const handleKeyDown = (e) => {
  const allowedKeys = ['0','1','2','3','4','5','6','7','8','9','.',','];
  const isControlKey = e.ctrlKey || e.metaKey || e.altKey ||
    ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Tab', 'Enter', 'Escape', 'Home', 'End'].includes(e.key);

  if (!isControlKey && !allowedKeys.includes(e.key)) {
    e.preventDefault();
    return false;
  }
};

// Fonction pour nettoyer la saisie en temps réel (sans ajouter au formulaire)
const handleInput = (e) => {
  let value = e.target.value;
  let originalValue = value;
  let cursorPosition = e.target.selectionStart;

  // Supprime tous les caractères non autorisés (y compris lettres)
  value = value.replace(/[^0-9.,]/g, '');

  // Remplace les virgules par des points pour normaliser
  value = value.replace(/,/g, '.');

  // Limite à un seul point décimal
  const parts = value.split('.');
  if (parts.length > 2) {
    value = parts[0] + '.' + parts.slice(1).join('');
  }

  // Limite les décimales à 2 chiffres
  if (parts[1] && parts[1].length > 2) {
    value = parts[0] + '.' + parts[1].substring(0, 2);
  }

  // Si la valeur a changé, on met à jour uniquement l'input
  if (value !== originalValue) {
    e.target.value = value;
    // Ajuste la position du curseur
    const lengthDiff = originalValue.length - value.length;
    const newCursorPos = Math.max(0, cursorPosition - lengthDiff);
    e.target.setSelectionRange(newCursorPos, newCursorPos);
  }
};

// Fonction pour sélectionner tout le contenu au focus
const handleFocus = (e) => {
  // Sélectionne tout le contenu de l'input
  e.target.select();
};

const InputNumber = (props) => {
  const [value, setValue] = useState(false);
  const {
    label,
    formItemName,
    inputName,
    objectValue,
    onBlur,
    suffix,
    readOnly,
    minLength,
    maxLength,
  } = props;

  useEffect(() => {
    objectValue ? setValue(objectValue) : setValue(false);
  }, [objectValue]);

  const onChange = (e) => {
    props.onChange && props.onChange(e);
    setValue(e.target.value);
  };

  const rules = [numericRule];

  return (
    <FloatLabel label={label} name={inputName} value={value}>
      <Form.Item name={formItemName} rules={rules}>
        <Input
          name={inputName}
          value={value}
          onChange={(e) => onChange(e)}
          type="text"
          suffix={suffix ? suffix : ""}
          readOnly={readOnly ? readOnly : false}
          minLength={minLength}
          maxLength={maxLength}
          onBlur={onBlur}
          onFocus={handleFocus}
          onKeyDown={handleKeyDown}      // Bloque la frappe de lettres
          onInput={handleInput}          // Nettoie la saisie (sans modifier le form)
          rules={rules}
        />
      </Form.Item>
    </FloatLabel>
  );
};

export default InputNumber;